"use client";

import { useQuery, type OptionalRestArgsOrSkip } from "convex/react";
import type { FunctionReference, FunctionReturnType } from "convex/server";
import { convexToJson } from "convex/values";
import { useLastLoaded } from "@/hooks/use-last-loaded";

type NowQuery = FunctionReference<"query", "public", { now?: number }>;

export function useNowQuery<Query extends NowQuery>(
  query: Query,
  ...args: OptionalRestArgsOrSkip<Query>
): FunctionReturnType<Query> | undefined {
  const fresh = useQuery(query, ...args);
  const [queryArgs] = args;
  const identity =
    queryArgs === "skip" ? "skip" : JSON.stringify(convexToJson({ ...queryArgs, now: 0 }));
  const held = useLastLoaded(fresh, identity);
  return identity === "skip" ? undefined : held;
}
